export const NotificationConstants = {
  SUCCESS: "success",
  ERROR: "danger",
  WARNING: "warning"
};
